import { MessageBulletedIcon } from './MessageBulletedIcon';

/**
 * author: Google
 * id 1EC9427A-2A02-4F74-9C1B-C4EC5E62B793
 * name message-bulleted
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-bulleted.svg
 * tags
 */
export const SpeakerNotesIcon = MessageBulletedIcon;
export default SpeakerNotesIcon